module.exports = __webpack_public_path__ + "img/green_143.8be9e410.png";